exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".control-lookup-editor.opened:not(.disabled).top-positioned input[data-v-9d11b5f2] {\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n", ""]);

// exports
